import type { QrYazdirEtiket } from './qrYazdir';

/** QR çerçeve renkleri: Lojistik mavi, Ambalaj turuncu, ofis mor (simülasyonla aynı). */
export const QR_RENKLERI = {
    lojistik: '#1b84ff',
    ambalaj: '#ea580c',
    ofis: '#5b4bd6',
};

export interface NoktaQrBilgisi {
    ad: string
    /** 1 Depo, 2 Ofis. */
    tur: number
    qrKodu: string | null
    qrMetni: string | null
    qrKoduAmbalaj?: string | null
    qrMetniAmbalaj?: string | null
}

/**
 * QR noktasının yazdırılacak etiketleri (QR Mesai Faz 2, 18.10.2026):
 * Depo → Lojistik (mavi) + Ambalaj (turuncu) birlikte; Ofis → tek etiket (iş tipi yok).
 * Eski kayıtta Ambalaj QR'ı henüz yoksa depo da tek (Lojistik) etiket basar.
 */
export const noktaEtiketleri = (n: NoktaQrBilgisi): QrYazdirEtiket[] => {
    var l: QrYazdirEtiket[] = [];

    if (!n.qrMetni)
        return l;

    if (n.tur == 2) {
        l.push({ baslik: n.ad, qrMetni: n.qrMetni, qrKodu: n.qrKodu ?? '' });
        return l;
    }

    l.push({ baslik: n.ad, qrMetni: n.qrMetni, qrKodu: n.qrKodu ?? '', isTipi: 'Lojistik', renk: QR_RENKLERI.lojistik });

    if (n.qrMetniAmbalaj)
        l.push({ baslik: n.ad, qrMetni: n.qrMetniAmbalaj, qrKodu: n.qrKoduAmbalaj ?? '', isTipi: 'Ambalaj', renk: QR_RENKLERI.ambalaj });

    return l;
}

/**
 * Depo'nun iki etiketi (Lojistik + Ambalaj) aynı satıra denk gelsin diye, çift tek sırada başlayacaksa araya boş hücre konur.
 * Boş hücre için qrMetni boş bırakılır.
 */
export const etiketleriDiz = (gruplar: QrYazdirEtiket[][]): QrYazdirEtiket[] => {
    var sonuc: QrYazdirEtiket[] = [];

    for (var g of gruplar) {
        if (g.length == 2 && sonuc.length % 2 == 1)
            sonuc.push({ baslik: '', qrMetni: '', qrKodu: '' });

        sonuc.push(...g);
    }

    return sonuc;
}
